import * as React from "react";
import { createSlotsContext } from "@grandvisionhq/slots";
import { DeliveryMethod } from "../../../../models/models/details-order.js";
import { ShippingSummarySlotTypes } from "./types.js";
const [OrderDetailsSummariesSlotsProvider, useBaseSummarySlot] = createSlotsContext({
  displayName: "OrderDetailsSummaryContext"
});
const useOrderDetailsSummariesSlot = (orderData) => {
  const { Slots } = useBaseSummarySlot();
  const summaries = Object.entries(Slots).reduce((summaryItem, [key, Slot]) => {
    let summaryData = orderData && orderData[key];
    if (orderData && key === "contactDetails") {
      const { firstName, lastName } = orderData[
        "billingAddress"
        /* BillingAddress */
      ];
      summaryData = { firstName, lastName, ...orderData.customerDetails };
    }
    if (orderData && key === "company") {
      const { company } = orderData[
        "billingAddress"
        /* BillingAddress */
      ];
      const { customerVatId, secondaryEmail } = orderData[
        "invoice"
        /* Invoice */
      ];
      summaryData = { name: company, customerVatId, secondaryEmail, ...summaryData };
    }
    if (key === ShippingSummarySlotTypes.Addresses) {
      const billingAddress = orderData?.billingAddress;
      const deliveryAddress = orderData?.shippingAddress;
      const isAddressesEqual = billingAddress?.postalCode === deliveryAddress?.postalCode && billingAddress?.streetName === deliveryAddress?.streetName && billingAddress?.streetNumber === deliveryAddress?.streetNumber;
      const isPickupOrder = orderData?.deliveryMethod === DeliveryMethod.Pickup || orderData?.deliveryMethod === DeliveryMethod.PickupPoint;
      summaryData = {
        billingAddress,
        deliveryAddress,
        isAddressesEqual,
        isPickupOrder
      };
    }
    summaryItem[key] = /* @__PURE__ */ React.createElement(Slot, { "data-t": `${key}Summary`, actions: void 0, values: summaryData });
    return summaryItem;
  }, {});
  return summaries;
};
export {
  OrderDetailsSummariesSlotsProvider,
  useBaseSummarySlot,
  useOrderDetailsSummariesSlot
};
//# sourceMappingURL=order-details-summary-context.js.map
